<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="Artist"
                        :label="$t('lang_LABEL_RELEASES_CAPTION_NAME')"
                        rules="required"
                        :withFreeText="false"
                        :withMargin="false"
                        :alvqa="alvqa + '-autocomplete-artist-textfield'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-artist-selection'">
                                <!-- {{ item.gemaName }}
                                <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                </span> -->
                                {{ $alvPlugin.showNameOfAzEntry(item) }}
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-artist-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-artist-dropdown-' + items.alvId + '-title'">
                                    <!-- {{ items.gemaName }}
                                    {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}} -->
                                    {{ $alvPlugin.showNameOfAzEntry(items) }}
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-artist-dropdown-' + items.alvId + '-subtitle'">
                                    {{ $t('lang_IPI') }}: {{ items.ipi !== '' ? items.ipi : $t('lang_GENERIC_CAPTION_NONE') }} | {{ items.alvId }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Role"
                        :items="roleItems"
                        :label="$t('lang_LABEL_RELEASES_ROLE')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-role'"
                    />
                </v-col>
                <v-col>
                    <!-- v-if="showPrimaryDropdown" -->
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Primary"
                        :items="yesNoItems"
                        :label="$t('lang_GENERIC_CAPTION_CHECKBOX_PRIMARY_ARTIST')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-primary'"
                    />
                </v-col>
                <v-col cols="1" align-self="center">
                    <BaseTooltip>
                        <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                        <template v-slot:text><span> {{ $t('lang_GENERIC_CAPTION_ARTISTS_PRIMARY_INFO_ICON') }} </span></template>
                    </BaseTooltip>
                </v-col>
            </v-row>
        </template>
        <template v-slot:checkboxSlot>
            <BaseCheckbox 
                :context="'Label' + context + 'PanelConnectToAllTracks'"
                :label="$t('lang_LABEL_RELEASES_CAPTION_ADD_TO_ALL_CONNECTED_TRACKS')" 
                hideDetails
                class="mt-0"
                :alvqa="alvqa + '-checkbox-add-to-connected-tracks'"
            />
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseCheckbox from '@/components/_base/BaseCheckbox'
import BaseTooltip from '@/components/_base/BaseTooltip'

import { DropdownGeneralArtistRoles, DropdownGenericYesNo } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "ReleasesArtistsEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageAutocomplete,
        BaseEditPageDropdown,
        BaseCheckbox,
        BaseTooltip
    },
    data() {
        return {
            context: "ReleasesArtists",
            alvqa: "label-releases-edit-form-panel-artists-editing-panel"
        }
    },
    computed: {
        roleItems() { 
            let roles = DropdownGeneralArtistRoles
            roles.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)

            return roles
        },
        yesNoItems() { return DropdownGenericYesNo },
        isReadonly() {
            let selectedRole = this.$store.getters.getReleasesArtistsDetailsRole

            switch(selectedRole) {
                case 'featuring': case 'with': case 'presents': case 'versus': case 'performer':
                    return false
                default:
                    this.$store.commit('setReleasesArtistsDetailsPrimary', 'no')
                    return true
            }
        }
        // showPrimaryDropdown() {
        //     let selectedRole = this.$store.getters.getReleasesArtistsDetailsRole

        //     switch(selectedRole) {
        //         case 'featuring': case 'with': case 'presents': case 'versus':
        //             return true
        //         default:
        //             this.$store.commit('setReleasesArtistsDetailsPrimary', 'no')
        //             return false
        //     }
        // }
    }
}
</script>